import produce from 'immer'
import { isError } from 'flux-standard-action'
import { isBoolean } from 'lodash'
import * as ActionTypes from 'actions/ActionTypes'
import { DEFAULT_PROJECT_OUTPUT_NAME } from '~/constant'
import { TASK_STATUS } from '~/enums'

const getInitialReference = () => ({
  id: null,
  width: null,
  height: null,
  fpsNum: null,
  fpsDenum: null,
  fileType: null,
})

const initialState = {
  editingTasks: [],
  outputName: DEFAULT_PROJECT_OUTPUT_NAME,
  outputPath: '',
  absFilePath: '',
  editing: false,
  loading: false,
  error: null,
  selectedTaskId: null,
  reference: getInitialReference(),
}
const setSelectedTask = (state, action) => {
  const { id } = action.payload
  state.selectedTaskId = id
}

const prepareTask = (state, action) => {
  const { name, path } = action.payload
  state.error = null
  state.loading = true
  state.outputName = name
  state.outputPath = path || ''
}

const resetTaskError = state => {
  state.error = null
  state.loading = false
}

const addTask = (state, action) => {
  if (isError(action)) {
    const { err } = action.payload
    state.error = err
    state.loading = false
    console.error(err)
    return
  }
  state.error = null
  state.editing = true
  if (action.meta.loading) {
    state.loading = true
  } else if (!action.meta.loading) {
    const { task } = action.payload
    if (task) {
      state.editingTasks.push(task)
      state.selectedTaskId = task.id
    }
  }
}

const deleteTask = (state, action) => {
  if (isError(action)) {
    const { err } = action.payload
    state.error = err
    console.error(err)
    return
  }
  const { taskId, isLoading } = action.payload
  state.editing = false
  state.editingTasks = state.editingTasks.filter(task => task.id !== taskId)
  if (taskId === state.selectedTaskId) {
    state.selectedTaskId = null
  }
  if (isBoolean(isLoading)) {
    state.loading = isLoading
  }
}

const updateTaskStatus = (state, action) => {
  const { task } = action.payload
  if (action.error) {
    const { id, message } = action.payload
    const failedTask = state.editingTasks.find(t => t.id === id)
    if (failedTask) {
      failedTask.error = message
      failedTask.status = TASK_STATUS.ABORTED
    }
    state.editing = false
  } else {
    const index = state.editingTasks.findIndex(x => x.id === task.id)
    if (index !== -1) {
      Object.assign(state.editingTasks[index], task)
    }
    if (state.editingTasks[index].status === TASK_STATUS.COMPLETED) {
      state.editing = false
    }
  }
}

const project = (state, action) => {
  // eslint-disable-next-line default-case
  switch (action.type) {
    case ActionTypes.ADD_EDITING_TASK:
      addTask(state, action)
      break
    case ActionTypes.PREPARE_EDITING_TASK:
      prepareTask(state, action)
      break
    case ActionTypes.DELETE_EDITING_TASK:
      deleteTask(state, action)
      break
    case ActionTypes.UPDATE_EDITING_TASK_STATUS:
      updateTaskStatus(state, action)
      break
    case ActionTypes.SET_SELECTED_TASK:
      setSelectedTask(state, action)
      break
    case ActionTypes.RESET_EDITING_TASK_ERROR:
      resetTaskError(state)
      break
    case ActionTypes.SET_ABS_FILE_PATH:
      state.absFilePath = action.payload.path
      break
    case ActionTypes.SET_REFERENCE: {
      const { width, height } = action.payload ?? {}
      if (!width || !height) {
        state.reference = getInitialReference()
      } else {
        state.reference = {
          ...state.reference,
          ...action.payload,
        }
      }
      break
    }
  }
}

export default produce(project, initialState)
